import loadScript from './loadScript';

const defaults = {
    url: '//res.wx.qq.com/open/js/jweixin-1.6.0.js', //微信JSSDK的URL
    config: {
        //默认配置
        debug: false,
        url: location.href.replace(location.hash, ''),
    },
    onError: function (msg) {
        console && console.error && console.error(msg);
    },
};

const states = ['not-auth', 'being-auth', 'auth-success', 'auth-fail'];
let excludeHashUrl = '';

if (!window._MTDPWxAuth_) {
    window._MTDPWxAuth_ = {
        state: states[0],
        callbackQueue: [],
    };
}

const queue = window._MTDPWxAuth_.callbackQueue;

const initWxConfig = (callback, opts) => {
    opts = opts || {};
    excludeHashUrl = excludeHashUrl || location.href.replace(location.hash, '');
    let options = defaults;

    // 如果当前是授权成功状态或者授权失败状态
    if (window._MTDPWxAuth_.state === states[2] || window._MTDPWxAuth_.state === states[3]) {
        return callback(window.wx);
    }

    // 任务入栈
    queue.push(callback);

    // 正在申请授权
    if (window._MTDPWxAuth_.state === states[1]) {
        return;
    }

    window._MTDPWxAuth_.state = states[1];

    const apis = `checkJsApi,onMenuShareTimeline,onMenuShareAppMessage,onMenuShareQQ,onMenuShareWeibo,onMenuShareQZone,startRecord,stopRecord,onVoiceRecordEnd,playVoice,pauseVoice,stopVoice,onVoicePlayEnd,uploadVoice,downloadVoice,chooseImage,previewImage,uploadImage,downloadImage,getLocalImgData,translateVoice,getNetworkType,openLocation,getLocation,hideOptionMenu,showOptionMenu,hideMenuItems,showMenuItems,hideAllNonBaseMenuItem,showAllNonBaseMenuItem,closeWindow,scanQRCode,chooseWXPay,openAddress,openProductSpecificView,addCard,chooseCard,openCard,startSearchBeacons,stopSearchBeacons,onSearchBeacons,launchMiniProgram,miniProgram,updateAppMessageShareData,updateTimelineShareData,launch3rdApp,launchApplication`;

    const configSearch = `?apis=${apis}${Object.entries(options.config)
        .map(([key, value]) => `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('')}`;

    const getAuthAndDoTask = function () {
        let doCallback = function () {
            window._MTDPWxAuth_.state = states[2];

            while (queue && queue.length) {
                let cb = queue.shift();
                cb && cb(window.wx);
            }
        };

        if (opts.account === 'meituan') {
            window.jsonpWXLoader = function (res) {
                const config = {
                    beta: true,
                    debug: options.config.debug,
                    appId: 'wxc72f01f43da0083b',
                    timestamp: res.data.timestamp,
                    signature: res.data.signature,
                    nonceStr: res.data.nonceStr,
                    jsApiList: apis.split(','),
                    openTagList: ['wx-open-launch-weapp'],
                };
                wx.config(config);
                doCallback();
            };
            loadScript('//ihotel.meituan.com/topcube/api/toc/weixin/getConfig?url=' + encodeURIComponent(excludeHashUrl) + '&callback=jsonpWXLoader');
        } else if (opts.account === 'ping51') {
            loadScript(`//tcps.51ping.com/weixin/config.js${configSearch}`, function () {
                doCallback();
            });
        } else if (opts.account === 'dianping') {
            loadScript(`//cps.dianping.com/weixin/config.js${configSearch}`, function () {
                doCallback();
            });
        } else {
            console.error('参数异常 opts.account:', opts.account);
        }
    };

    loadScript(options.url, function () {
        getAuthAndDoTask();
    });
};

export default initWxConfig;
